import { useRef, useEffect } from 'react';
import { useDrag } from './DragContext';

export default function DragPhantom() {
  const { isDragging, draggedItem, isCompact, initialMousePos } = useDrag();
  const phantomRef = useRef(null);

  const width = isCompact ? 160 : 208;
  const height = isCompact ? 96 : 128;
  const offsetX = width / 2;
  const offsetY = height / 2;

  useEffect(() => {
    if (!isDragging || !phantomRef.current) return;

    const handleMouseMove = (e) => {
      if (phantomRef.current) {
        phantomRef.current.style.transform = `translate(${e.clientX - offsetX}px, ${e.clientY - offsetY}px)`;
      }
    };

    document.addEventListener('mousemove', handleMouseMove, { passive: true });

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, [isDragging, isCompact, offsetX, offsetY]);

  if (!isDragging || !draggedItem) {
    return null;
  }

  return (
    <div
      ref={phantomRef}
      className="fixed pointer-events-none z-50 opacity-70 no-transition"
      style={{
        left: 0,
        top: 0,
        transform: `translate(${initialMousePos.x - offsetX}px, ${initialMousePos.y - offsetY}px)`,
        willChange: 'transform',
      }}
    >
      <div className={`bg-gray-800 border-2 border-purple-500 rounded-xl shadow-2xl flex flex-col justify-between select-none ${isCompact ? 'w-40 h-24 p-3' : 'w-52 h-32 p-4 sm:p-5'}`}>
        <div className="flex items-start space-x-2">
          <svg className={`text-blue-400 flex-shrink-0 mt-0.5 ${isCompact ? 'w-3 h-3 sm:w-4 sm:h-4' : 'w-4 h-4 sm:w-5 sm:h-5'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <p className={`text-white font-semibold line-clamp-2 ${isCompact ? 'text-xs' : 'text-sm'}`}>{draggedItem.title}</p>
        </div>
        <div className={`border-t border-gray-600 pt-1.5 ${isCompact ? 'mt-1' : 'mt-2'}`}>
          <p className="text-[10px] text-gray-400 uppercase tracking-wider">Linked Item</p>
        </div>
      </div>
    </div>
  );
}
